export default __webpack_public_path__ + "static/balance-128dc3d9eb203ac97044ddcdc6e5539b.webp";